import React from 'react';
import b from 'b_';
import { isTomorrow, isToday, getYear } from 'date-fns';
import { formatDate } from 'client/helpers/formatDate';
import { Event, RegistrationStatus } from 'client/types/event';

import './event-card.css';

const class_ = b.with('event-card');

interface Props {
    data: Event;
}

function getStatus(registrationStatus: RegistrationStatus) {
    const statuses: { [key: string]: string; } = {
        [RegistrationStatus.CLOSED]: 'Регистрация закрыта',
        [RegistrationStatus.OPENED]: 'Регистрация открыта'
    };

    return statuses[registrationStatus] || '';
}

function getDate(startDate: Date | null) {
    if (!startDate) {
        return '';
    }

    // Удаляем таймзону и показываем время по местному времени,
    // Которое соответствует времени городу проведения события
    const dateWithoutTimezone = startDate
        .toString()
        .replace(/\+.*/, '');

    if (isToday(dateWithoutTimezone)) {
        return `сегодня в ${formatDate(dateWithoutTimezone, 'H:mm')}`;
    } else if (isTomorrow(dateWithoutTimezone)) {
        return `завтра в ${formatDate(dateWithoutTimezone, 'H:mm')}`;
    }

    if (getYear(startDate) !== getYear(Date.now())) {
        return formatDate(dateWithoutTimezone, 'dd, D MMMM YYYY');
    }

    return formatDate(dateWithoutTimezone, 'dd, D MMMM');
}

// eslint-disable-next-line complexity
export default function (props: Props) {
    const {
        id,
        slug,
        title,
        city,
        registrationStatus: status,
        startDate,
        isFinished,
        image,
        redirectUrl
    } = props.data;

    const imageStyles = image ? { backgroundImage: `url(${image})` } : {};
    const highlighted = isToday(startDate as Date) || isTomorrow(startDate as Date);

    return (
        <div data-id={id} className={class_({ highlighted, finished: !highlighted && isFinished })}>
            <a href={redirectUrl || `/events/${slug}`} title={title}>
                <div className={class_('image')} style={imageStyles} />
            </a>
            <div className={class_('container')}>
                <div className={class_('date')}>
                    {[getDate(startDate), city].filter(Boolean).join(', ')}
                </div>
                <a
                    href={redirectUrl || `/events/${slug}`}
                    className={class_('title')}
                    title={title}
                    dangerouslySetInnerHTML={{ __html: title }}
                />
                {!isFinished && (
                    <div className={class_('registration', { status })}>
                        {getStatus(status)}
                    </div>
                )}
            </div>
        </div>
    );
}
